<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->
<div class="row full-width flex-column text-align-center attachment-upload position-relative p pb-lg mx-none" data-testid="attachment-upload">
  <p-fileUpload #fileUploader
                name="files"
                styleClass="file-uploader"
                data-testid="file-uploader"
                [mode]='"advanced"'
                [accept]="accept"
                [multiple]="multiple"
                [maxFileSize]="maxFileSize"
                [customUpload]="true"
                [files]="localFiles"
                (onSelect)='fileUploader.mode = "basic"'
                (uploadHandler)="uploadHandler($event)"
                (onRemove)="onRemove($event)"
                [auto]="true"
                [chooseLabel]="chooseFileButtonLabel"
                [showUploadButton]="false"
                [showCancelButton]="false"
  >
    <ng-template let-file pTemplate="file">
      <div class="p-fileupload-row">
        <div>
          <ng-container *ngIf="fileUploader.isImage(file); else isFile;">
            <img [src]="file.objectURL" *ngIf="fileUploader.isImage(file)" [width]="50"/>
          </ng-container>
          <ng-template #isFile>
            <i class="ui-icon-insert-drive-file file-icon"></i>
          </ng-template>
        </div>
        <div class="p-fileupload-file-name word-break-all">{{file.name}}</div>
        <div>{{fileUploader.formatSize(file.size)}}</div>
        <div>
          <button type="button" icon="pi pi-times" pButton
                  (click)="fileUploader.remove($event,localFiles.indexOf(file))"
                  [disabled]="fileUploader.uploading" data-testid="file-uploader-remove-btn"></button>
        </div>
      </div>
    </ng-template>
    <ng-template let-content pTemplate="content">
      <div class="text mt-sm">
        <i class="ui-icon-file-upload icon"></i>
        <p class="w300">{{"fileStorage.dragAndDrop" | translate}}</p>
      </div>
    </ng-template>
  </p-fileUpload>
</div>


